import actions from '../../actions/BenefitsSetIdentifiers'
import connectIndex from '../../lib/connectIndex'
import BulkIdentifierComponent from '../common/BulkIdentifierComponent'

export default connectIndex(
  BulkIdentifierComponent,
  'benefitsSetIdentifiers',
  actions,
  [],
  {
    indexParams: { product_line: 'medicare_advantage' },
    redirectTo: '/med_adv_benefits/bulk'
  }
)
